/** CSS contract: css-library/components/02-containers/form.css. */
import type { Ref } from 'react'
import { useRef } from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from '../lib/cx'
import { mergeRefs } from '../lib/merge-refs'
import { ScrollBar } from './ScrollBar'

export type FormScrollProps = HTMLAttributes<HTMLElement>

export function FormScroll({ ref, className, children, ...rest }: FormScrollProps & { ref?: Ref<HTMLElement> }) {
  const scrollerRef = useRef<HTMLElement>(null)
  return (
    <>
      <main ref={mergeRefs(scrollerRef, ref)} className={cx('form', className)} data-scroll-host {...rest}>
        {children}
      </main>
      <ScrollBar scrollerRef={scrollerRef} />
    </>
  )
}

export interface FormSectionProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'section'
  label?: ReactNode
  compact?: boolean
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export function FormSection({
  ref,
  as: Element = 'section',
  label,
  compact = false,
  headingLevel = 'h2',
  className,
  children,
  ...rest
}: FormSectionProps & { ref?: Ref<HTMLElement> }) {
  const Heading = headingLevel
  return (
    <Element ref={ref as Ref<HTMLDivElement>} className={cx('section', compact && 'section--compact', className)} {...rest}>
      {label != null && <Heading className="section-header">{label}</Heading>}
      <div className="section-body">{children}</div>
    </Element>
  )
}
